import createRoute        from '@widesk-ui/tools/createRoute';
import OrderItemUnitModel from '@models/shop/OrderItemUnitModel';

export default createRoute.dashboard('/order_item_units', 'shop', 'OrderItemUnitDashboard', OrderItemUnitModel.localize());
